module.exports = __webpack_public_path__ + "static/media/bonus.98696fc5.svg";